module.exports = __webpack_public_path__ + "static/22_tat13-c76f613e9ffee7cdccb74fdb0b18c13f.jpg";